import React from 'react';
import { spaces, typography } from '../../../assets/styles/themes/tokens';
import { Box, Divider, Typography } from '@mui/material';

interface SectionHeaderProps {
  isCollapsed: boolean;
  title?: string;
}

export const SectionHeader = ({ isCollapsed, title }: SectionHeaderProps) => {
  if (isCollapsed) {
    return (
      <Box sx={{ padding: spaces.xxs }}>
        <Divider />
      </Box>
    );
  }

  return (
    <Box sx={{ padding: spaces.sm, paddingBottom: spaces.xxs }}>
      <Typography sx={typography.caption}>{title}</Typography>
    </Box>
  );
};
